import { Link } from "react-router-dom";
import SideBareMagasin from "../SideBareMagasin/SideBareMagasin";
import "../commercial/commercial.css";
import { MagasinContext } from "../../../Context/MagasinContext";
import { useContext, useEffect, useState } from "react";
import { ClientInfo } from "../../../Modeles/Client";
import AfficheClient from "../../../Services/Magasin/AfficheClient";
import SideBarMagasinMobile from "../SideBareMagasin/SidebarMagasinMobile";
import { NewSideBarMagasins } from "../../NewSidebarMagasin";
import axios from "axios";

export interface ProductType {
  product: ClientInfo[];
  messageErros: string;
}

export default function Client() {
  const magasinContext = useContext(MagasinContext);
  const [search, setSearch] = useState("");
  const MagasinId = localStorage.getItem("MagasinId");
  const id = MagasinId || magasinContext.id?.id;

  const [state, setState] = useState<ProductType>({
    product: [] as ClientInfo[],
    messageErros: "aucun client",
  });

  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState<boolean>(true);
  const [activeDropdownId, setActiveDropdownId] = useState<number | null>(null);
  const [MessageSuccess, setMessageSuccess] = useState<string>("");
  const [visiblePasswordIds, setVisiblePasswordIds] = useState<Set<number>>(new Set());

  useEffect(() => {
    setLoading(true);
    AfficheClient(id)
      .GetClient()
      .then((res) => {
        setState({ ...state, product: res.data });
        setLoading(false);
      })
      .catch((msg) => {
        setState({ ...state, product: msg.messageErros });
        setLoading(false);
      });
  }, [id]);

  const handleSearch = (e: any) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const handleChangePage = (pageNumber: number) => setCurrentPage(pageNumber);

  const toggleDropdown = (id: any) => {
    setActiveDropdownId((prevId) => (prevId === id ? null : id));
  };

  const togglePasswordVisibility = (id: number) => {
    setVisiblePasswordIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const HandleDeleteClient = async (IdClient: number) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/magasins/${id}/clients/${IdClient}/delete`
      );
      if (response.status === 200)
        setMessageSuccess("Le client a bien été supprimé");
    } catch (error) {
      console.error(error);
      setMessageSuccess("Erreur lors de la suppression du client");
    } finally {
      setLoading(false);
    }
  };

  const { product } = state;

  const filteredProducts = (product ?? []).filter((pro) => {
    const searchTerm = search.trim().toLowerCase().replace(/\s+/g, "");
    const nom = pro.NomClient ? pro.NomClient.toLowerCase().replace(/\s+/g, "") : "";
    const prenom = pro.PrenomClient ? pro.PrenomClient.toLowerCase().replace(/\s+/g, "") : "";
    return nom.includes(searchTerm) || prenom.includes(searchTerm);
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredProducts.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ─── MOBILE VIEW ─────────────────────────────── */
  if (screenWidth <= 450) {
    return (
      <>
        <NewSideBarMagasins />

        {loading ? (
          <div className="loader-wrapper-cmu">
            <div className="custom-spinner-cmu" role="status" />
            <span className="loader-charg-cmu">Chargement</span>
          </div>
        ) : (
          <div className="container-commercial-mobile-cmu">
            <h1 className="title-commercial-mobile-cmu">Liste des clients</h1>

            {/* Search */}
            <div className="search-bar-commercial-mobile-cmu">
              <input
                type="text"
                placeholder="Chercher un client..."
                onChange={handleSearch}
                value={search}
              />
              <i className="bi bi-search" />
            </div>

            {/* Cards */}
            <div className="cards-commercial-mobile-cmu">
              {currentItems && currentItems.length > 0 ? (
                currentItems.map((client) => (
                  <div key={client.id} className="card-commercial-mobile-cmu">
                    <div className="card-header-commercial-mobile-cmu">
                      <div className="user-info-commercial-mobile-cmu">
                        <div className="dot-commercial-mobile-cmu">
                          {client.NomClient?.charAt(0)?.toUpperCase()}
                        </div>
                        <div className="user-details-commercial-mobile-cmu">
                          <h2>
                            {client.NomClient} {client.PrenomClient}
                          </h2>
                          <p>{client.Email}</p>
                          <p>{client.Tele}</p>
                          {/* ── Password row in mobile card ── */}
                          <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "2px" }}>
                            <span style={{ fontSize: "14px", letterSpacing: "1px" }}>
                              {visiblePasswordIds.has(client.id)
                                ? client.Password ?? client.Password ?? client.Password ?? "—"
                                : "•".repeat(8)}
                            </span>
                            <i
                              className={`bi ${visiblePasswordIds.has(client.id) ? "bi-eye-slash" : "bi-eye"}`}
                              onClick={() => togglePasswordVisibility(client.id)}
                              style={{ cursor: "pointer", color: "#6c757d", fontSize: "14px" }}
                              title={visiblePasswordIds.has(client.id) ? "Masquer" : "Afficher"}
                            />
                          </div>
                        </div>
                      </div>
                      <i
                        className="bi bi-three-dots-vertical menu-icon-commercial-mobile-cmu"
                        onClick={() => toggleDropdown(client.id)}
                      />
                      <div
                        className={`dropdown-commercial-cmu ${
                          activeDropdownId === client.id ? "open-cmu" : ""
                        }`}
                      >
                        <Link
                          className="dropdown-item-cmu"
                          to={`/magasins/${id}/clients/${client.id}`}
                        >
                          <i className="bi bi-eye" /> Voir
                        </Link>
                        <button
                          className="dropdown-item-cmu danger-cmu"
                          onClick={() => HandleDeleteClient(client.id)}
                          style={{
                            background: "none",
                            border: "none",
                            width: "100%",
                            textAlign: "left",
                            padding: 0,
                          }}
                        >
                          <i className="bi bi-trash3" /> Supprimer
                        </button>
                      </div>
                    </div>

                    <div className="card-footer-commercial-mobile-cmu">
                      <div className="footer-item-commercial-mobile-cmu">
                        <p className="number-commercial-mobile-cmu">
                          {client.RemiseGlobal}%
                        </p>
                        <p>Remise</p>
                      </div>
                      <div className="footer-item-commercial-mobile-cmu">
                        <p className="number-commercial-mobile-cmu">
                          {client.credit ?? client.Credit ?? 0} MAD
                        </p>
                        <p>Solde</p>
                      </div>
                      <div className="footer-item-commercial-mobile-cmu">
                        <p className="number-commercial-mobile-cmu">
                          {client.Adresse || "N/A"}
                        </p>
                        <p>Ville</p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="commercial-non-trouve-cmu">
                  <i className="bi bi-search" />
                  <h3>Aucun client trouvé</h3>
                  <p>Cliquez sur le bouton + pour ajouter un nouveau client</p>
                </div>
              )}
            </div>

            <Link to={`/magasins/${id}/clients/add`}>
              <button className="add-button-commercial-mobile-cmu">
                <i className="bi bi-plus" />
              </button>
            </Link>
          </div>
        )}
      </>
    );
  }

  /* ─── DESKTOP VIEW ────────────────────────────── */
  return (
    <>
      <NewSideBarMagasins />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />

      {loading ? (
        <div className="loader-wrapper-cmu">
          <div className="custom-spinner-cmu" role="status" />
          <span className="loader-charg-cmu">Chargement</span>
        </div>
      ) : (
        <div className="container-cmu">
          {/* Toolbar */}
          <div className="toolbar-cmu">
            <div className="search-wrapper-cmu">
              <input
                type="text"
                placeholder="Rechercher un client..."
                onChange={handleSearch}
                value={search}
              />
              <i className="bi bi-search search-icon-cmu" />
            </div>
            <Link to={`/magasins/${id}/clients/add`}>
              <button className="btn-ajoute-cmu">
                <i className="bi bi-person-plus" /> Ajouter un Client
              </button>
            </Link>
          </div>

          <div className="table-infos-cmu">
            {MessageSuccess && (
              <div className="alert-success-cmu" style={{ margin: "16px 16px 0" }}>
                <i className="bi bi-check2-circle" /> {MessageSuccess}
              </div>
            )}

            <table className="table-cmu">
              <thead>
                <tr>
                  <th>Prénom</th>
                  <th>Nom</th>
                  <th>Email</th>
                  <th>Mot de passe</th>
                  <th>Téléphone</th>
                  <th>Ville</th>
                  <th>Remise</th>
                  <th>Solde</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems && currentItems.length > 0 ? (
                  currentItems.map((pro: any, index: number) => (
                    <tr key={index}>
                      <td>{pro.PrenomClient}</td>
                      <td>{pro.NomClient}</td>
                      <td>{pro.Email}</td>

                      {/* ── Password cell with eye toggle ── */}
                      <td>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <span style={{ letterSpacing: "2px", fontSize: "16px" }}>
                            {visiblePasswordIds.has(pro.id)
                              ? pro.Password ?? pro.password ?? pro.MotDePasse ?? "—"
                              : "•".repeat(8)}
                          </span>
                          <i
                            className={`bi ${visiblePasswordIds.has(pro.id) ? "bi-eye-slash" : "bi-eye"}`}
                            onClick={() => togglePasswordVisibility(pro.id)}
                            style={{
                              cursor: "pointer",
                              color: "#6c757d",
                              fontSize: "16px",
                              flexShrink: 0,
                            }}
                            title={visiblePasswordIds.has(pro.id) ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                          />
                        </div>
                      </td>

                      <td>{pro.Tele}</td>
                      <td>{pro.Adresse || "N/A"}</td>
                      <td className="cell-vendu-cmu">{pro.RemiseGlobal}</td>
                      <td className="cell-cours-cmu">{pro.credit ?? pro.Credit ?? 0} MAD</td>
                      <td>
                        <div className="actions-cmu">
                          <Link
                            className="btn-edit-cmu"
                            to={`/magasins/${id}/clients/${pro.id}`}
                          >
                            <i className="bi bi-pencil-square" />
                          </Link>
                          <button
                            className="btn-delete-cmu"
                            onClick={() => HandleDeleteClient(pro.id)}
                          >
                            <i className="bi bi-trash3" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="empty-row-cmu">
                    <td colSpan={9}>
                      <i className="bi bi-inbox me-2" /> Aucun Client trouvé
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Pagination */}
            {pageNumbers.length > 1 && (
              <div className="pagination-cmu">
                <button
                  onClick={() => handleChangePage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  ← Précédent
                </button>
                {pageNumbers.map((number) => (
                  <button
                    key={number}
                    className={currentPage === number ? "active-cmu" : ""}
                    onClick={() => handleChangePage(number)}
                  >
                    {number}
                  </button>
                ))}
                <button
                  onClick={() => handleChangePage(currentPage + 1)}
                  disabled={
                    currentPage === Math.ceil(filteredProducts.length / itemsPerPage)
                  }
                >
                  Suivant →
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}